import * as api from '../coOpApi';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
    coOpActionCreators,
    CoOpActionKeys,
    ICoOpSalesDistrictBudget,
    UpdateCoOpSalesDistrictBudgets
    } from '..';
import { uiActionCreators } from '../../ui';

function* updateCoOpSalesDistrcitBudgetsSaga(action: UpdateCoOpSalesDistrictBudgets) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response: ICoOpSalesDistrictBudget[] = yield call(api.updateCoOpSalesDistrictBudgets, action.payload);

  yield put(coOpActionCreators.setSalesDistrictBudgets(response));
  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchUpdateCoOpSalesDistrictBudgets() {
  yield takeEvery(CoOpActionKeys.UPDATE_COOP_SALESDISTRICT_BUDGETS, updateCoOpSalesDistrcitBudgetsSaga);
}
